module.exports = __webpack_public_path__ + "static/media/consultationEnd.f21f9414.jpg";